import type {PageProps} from '@hconnect/uikit/src/lib2'
import {mergeSx, Page} from '@hconnect/uikit/src/lib2'
import React, {useEffect} from 'react'

export type PlannerPageLayoutProps = Partial<
  Pick<
    PageProps,
    | 'title'
    | 'headerActionContent'
    | 'nameHeaderSx'
    | 'nameBodySx'
    | 'sxActionContent'
    | 'aboveTitle'
    | 'sx'
    | 'data-test-id'
  >
> & {
  pageTitle?: string
  children: React.ReactNode
}

export const PlannerPageLayout = ({
  nameHeaderSx,
  children,
  pageTitle,
  ...props
}: PlannerPageLayoutProps) => {
  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle
    }
  }, [pageTitle])

  return (
    <Page
      sx={{
        px: {
          xs: 2,
          lg: 6
        }
      }}
      boxed={false}
      nameHeaderSx={mergeSx({mb: 1.5, px: 3}, nameHeaderSx)}
      {...props}
    >
      {children}
    </Page>
  )
}

PlannerPageLayout.displayName = 'PlannerPageLayout'
